import { render, staticRenderFns } from "./bookmark-button.vue?vue&type=template&id=48acf4e6&"
import script from "./bookmark-button.vue?vue&type=script&lang=js&"
export * from "./bookmark-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports